import React from "react";
import * as Icon from "react-feather";

const horizontalMenuConfig = [
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <Icon.Home size={20} />,
    navLink: "/",
  },
  {
    type: "groupHeader",
    groupTitle: "DATA DISPLAY",
  },
  {
    id: "analytics",
    title: "Analytics",
    type: "item",
    icon: <Icon.TrendingUp size={20} />,
    navLink: "/cards/analytics",
  },
  {
    id: "dataTable",
    title: "DataTables",
    type: "item",
    icon: <Icon.Server size={20} />,
    navLink: "/tables/data-tables",
  },
  {
    id: "statistics",
    title: "Statistics",
    type: "item",
    icon: <Icon.BarChart2 size={20} />,
    navLink: "/cards/statistics",
  },
  {
    type: "groupHeader",
    groupTitle: "WEB APPS",
  },
  {
    id: "todo",
    title: "Tasks",
    type: "item",
    icon: <Icon.List size={20} />,
    navLink: "/todo/:filter",
    filterBase: "/todo/all",
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <Icon.Mail size={20} />,
    navLink: "/email/:filter",
    filterBase: "/email/inbox",
  },
  {
    id: "chat",
    title: "Messenger",
    type: "item",
    icon: <Icon.MessageSquare size={20} />,
    navLink: "/chat",
  },
  {
    id: "calendar",
    title: "Calendar",
    type: "item",
    icon: <Icon.Calendar size={20} />,
    navLink: "/calendar",
  },
  {
    type: "groupHeader",
    groupTitle: "E-COMMERCE PAGES",
  },
  {
    id: "shop",
    title: "Shop",
    type: "item",
    icon: <Icon.ShoppingCart size={20} />,
    navLink: "/ecommerce/shop",
  },
  {
    id: "detail",
    title: "Item Details",
    type: "item",
    icon: <Icon.AlignCenter size={20} />,
    navLink: "/ecommerce/product-detail",
  },
  {
    id: "wishList",
    title: "Wish List",
    type: "item",
    icon: <Icon.Heart size={20} />,
    navLink: "/ecommerce/wishlist",
  },
  {
    id: "checkout",
    title: "Checkout",
    type: "item",
    icon: <Icon.DollarSign size={20} />,
    navLink: "/ecommerce/checkout",
  },
  {
    type: "groupHeader",
    groupTitle: "CONTENT",
  },
  {
    id: "typography",
    title: "Typography",
    type: "item",
    icon: <Icon.Type size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/ui-element/typography",
  },
  {
    id: "textUitlities",
    title: "Text Utilities",
    type: "item",
    icon: <Icon.Edit3 size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/ui-element/textutilities",
  },
  {
    id: "components",
    title: "Components",
    type: "collapse",
    icon: <Icon.Grid size={20} />,
    children: [
      {
        id: "alerts",
        title: "Alerts",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/alerts",
      },
      {
        id: "buttons",
        title: "Buttons",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/buttons",
      },
      {
        id: "breadCrumbs",
        title: "Breadcrumbs",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/breadcrumbs",
      },
      {
        id: "carousel",
        title: "Carousel",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/carousel",
      },
      {
        id: "collapse",
        title: "Collapse",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/collapse",
      },
      {
        id: "dropDowns",
        title: "Dropdowns",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/dropdowns",
      },
      {
        id: "listGroup",
        title: "List Group",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/list-group",
      },
      {
        id: "modals",
        title: "Modals",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/modals",
      },
      {
        id: "pagination",
        title: "Pagination",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/pagination",
      },
      {
        id: "navsComponent",
        title: "Navs Component",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/nav-component",
      },
      {
        id: "navbar",
        title: "Navbar",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/navbar",
      },
      {
        id: "tabsComponent",
        title: "Tabs Component",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/tabs-component",
      },
      {
        id: "pillsComponent",
        title: "Pills Component",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/pills-component",
      },
      {
        id: "tooltips",
        title: "Tooltips",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/tooltips",
      },
      {
        id: "popovers",
        title: "Popovers",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/popovers",
      },
      {
        id: "badges",
        title: "Badges",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/badges",
      },
      {
        id: "pillBadges",
        title: "Pill Badges",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/pill-badges",
      },
      {
        id: "progress",
        title: "Progress",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/progress",
      },
      {
        id: "mediaObjects",
        title: "Media Objects",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/media-objects",
      },
      {
        id: "spinners",
        title: "Spinners",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/spinners",
      },
      {
        id: "toasts",
        title: "Toasts",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/components/toasts",
      },
    ],
  },
  {
    id: "formElements",
    title: "Form Elements",
    type: "collapse",
    icon: <Icon.Edit size={20} />,
    children: [
      {
        id: "select",
        title: "Select",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/forms/elements/select",
      },
      {
        id: "switch",
        title: "Switch",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/forms/elements/switch",
      },
      {
        id: "checkbox",
        title: "Checkbox",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/forms/elements/checkbox",
      },
      {
        id: "radio",
        title: "Radio",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/forms/elements/radio",
      },
      {
        id: "input",
        title: "Input",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/forms/elements/input",
      },
      {
        id: "inputGroup",
        title: "Input Group",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/forms/elements/input-group",
      },
      {
        id: "numberInput",
        title: "Number Input",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/forms/elements/number-input",
      },
      {
        id: "textarea",
        title: "Textarea",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/forms/elements/textarea",
      },
      {
        id: "date_&_timePicker",
        title: "Date & Time Picker",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/forms/elements/pickers",
      },
      {
        id: "inputMask",
        title: "Input Mask",
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: "/forms/elements/input-mask",
      },
    ],
  },
  {
    id: "formLayouts",
    title: "Form Layouts",
    type: "item",
    icon: <Icon.Layout size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/forms/layout/form-layout",
  },
];

export default horizontalMenuConfig;
